module.exports = __webpack_public_path__ + "img/rightside_1000.af5488da.jpg";